import { Component, OnInit, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit, NgZone } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { SharedService } from '../../../services/shared.service';
import { CryptoService } from "../../../services/crypto.service";
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'support-card-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class SupportCardRegisterComponent implements OnInit, AfterViewInit {
  years: string[];
  months: number[];
  cardForm: any = {
    number: '',
    name: '',
    expire_month: '',
    expire_year: ''
  }
  errors: string[] = [];
  isCompleted: boolean = false;
  isFailed: boolean = false;

  @ViewChild('payform', {static: true}) payform: ElementRef;
  @Output() back = new EventEmitter();

  constructor(
      public auth: AuthService,
      private shared: SharedService,
      private ngZone: NgZone,
      public crypto: CryptoService
    ) {}

  ngOnInit() {
    this.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const currentYear = new Date().getFullYear();
    this.years = []
    for (let i = 0; i <= 10; i++) {
      this.years.push('' + (currentYear + i));
    }
    this.cardForm.expire_month = this.months[0];
    this.cardForm.expire_year = this.years[0];

    // Already Registered
    if (this.auth.user.card) {
      this.cardForm = Object.assign({}, this.auth.user.card)
      this.cardForm.name = this.crypto.decrypt(this.cardForm.name)
      this.cardForm.expire_month = parseInt(this.crypto.decrypt(this.cardForm.expire_month))
      this.cardForm.expire_year = parseInt(this.crypto.decrypt(this.cardForm.expire_year))
      this.cardForm.number = this.crypto.decrypt(this.cardForm.number)
    }

    window['angularComponentReference'] = { component: this, zone: this.ngZone, onTokenCreated: (response) => this.onTokenCreated(response), onTokenFailed: () => this.onTokenFailed(), };
  }

  ngAfterViewInit() {
    let renderer = document.createElement("script");
    renderer.type = "text/javascript";
    renderer.src = "https://checkout.pay.jp/"
    renderer.setAttribute("class", "payjp-button")
    renderer.setAttribute("data-key", environment.payjp_public)
    renderer.setAttribute("data-on-created", "onTokenCreated")
    renderer.setAttribute("data-on-failed", "onTokenFailed")
    renderer.setAttribute("data-partial", "true")
    this.payform.nativeElement.appendChild( renderer );
  }

  onTokenCreated(tokenResponse) {
    this.auth.toggleSpinner(true);

    this.cardForm.name = tokenResponse.card.name
    this.cardForm.number = tokenResponse.card.last4
    this.cardForm.expire_month = tokenResponse.card.exp_month
    this.cardForm.expire_year = tokenResponse.card.exp_year

    this.auth.createCustomer(tokenResponse.id, this.cardForm.name)
      .then((cardResponse: any) => {
        cardResponse = cardResponse.data

        if (cardResponse.id) {
          this.doCardSave(cardResponse.id)
        } else {
          this.doCardSave(this.auth.decrypt(this.auth.user.card_customer.id))
        }
      })
      .catch(error => {
        console.log(error)
        this.isFailed = true;
        this.auth.toggleSpinner(false)
      })
    
    this.isFailed = false;
  }

  onTokenFailed() {
    this.isFailed = true;
  }

  // canRegister() {
  //   if (this.cardForm.number === '' || this.cardForm.name === '') {
  //     return false;
  //   }

  //   return true;
  // }

  doCardSave(cid) {
    let card = Object.assign({}, this.cardForm);
    card.name = this.crypto.encrypt(card.name)
    card.expire_year = this.crypto.encrypt("" + card.expire_year)
    card.expire_month = this.crypto.encrypt("" + card.expire_month)
    card.number = this.crypto.encrypt("" + card.number)

    cid = this.crypto.encrypt(cid)

    let params = {
      uid: this.auth.user.uid,
      card: card,
      card_customer: {
        id: cid
      }
    }

    this.auth.updateUserData(params)
    .then(() => {
      this.auth.getUser().then(response => {
        this.auth.setUser(response);
        this.auth.toggleSpinner(false);

        this.back.emit();
      })
    })
  }

  hasError(value: string): boolean {
    return this.errors.indexOf(value) >= 0;
  }
}
